import React from 'react'
import PromoUpdate from '../promo_components/promo_update'

export default function Main() {
  return (
    <div className='content-wrapper bg-white p-5' style={{ marginLeft: 0 }}>
      <div>
        <h2>Update Promotion</h2>
        <PromoUpdate />
      </div>
    </div>
  )
}
